import { createSlice } from '@reduxjs/toolkit';

export const defaultState: Fields = {
  isModalOpen: false,
};

interface Fields {
  isModalOpen: boolean;
}

const slice = createSlice({
  name: 'add-asset',
  initialState: defaultState,
  reducers: {
    toggleAssetTypesModalOpen: (state) => {
      state.isModalOpen = !state.isModalOpen;
    },
    closeModal: (state) => {
      state.isModalOpen = false;
    },
  },
});

export const { toggleAssetTypesModalOpen, closeModal } = slice.actions;
export default slice.reducer;
